<template>
  <v-row>
    <v-col md="12" lg="12" sm="12">
      <v-card-title>Step 1: Get token for FXCM DEMO Account</v-card-title>
      <v-card-subtitle>
        Find token in the Trading Station
        <a
          href="https://tradingstation.fxcm.com/"
          target="fxcm"
        >https://tradingstation.fxcm.com/</a>.
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col sm="12" md="4" lg="4">
            <v-img src="@/assets/brokers/fxcm/step1.jpg"></v-img>
          </v-col>
          <v-col sm="12" md="4" lg="4">
            <v-img src="@/assets/brokers/fxcm/step2.jpg"></v-img>
          </v-col>
          <v-col sm="12" md="4" lg="4">
            <v-img src="@/assets/brokers/fxcm/step3.jpg"></v-img>
          </v-col>
        </v-row>
      </v-card-text>
    </v-col>
    <v-col md="12" lg="12" sm="12">
      <v-card-title>Step 1: Get token for FXCM REAL Account</v-card-title>
      <v-card-subtitle>
        Please send an email with you user name to
        <a href="mailto:api@fxcm.com">api@fxcm.com</a> to get RESTful API access and to activate your token, respectively.
      </v-card-subtitle>
    </v-col>
    <v-col sm="12" md="12" lg="12">
      <v-card flat>
        <v-card-title>Step 2: Checking API and get Account's informations</v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-switch v-model="real" label="Is Real Account?"></v-switch>
            <v-text-field
              v-model="token"
              label="Token"
              :rules="[v => !!v || 'Field is required']"
              clearable
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            outlined
            :loading="loading"
            :disabled="!valid"
            @click="onToken"
          >Check Token & Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ApiService from "@/common/api.service";
import { SCHEMA, ERROR } from "@/store/actions.type";
export default {
  name: "FXCM",
  data() {
    return {
      real: false,
      valid: false,
      token: null,
      loading: false,
      accounts: []
    };
  },
  methods: {
    async convertAccounts(accounts) {
      this.accounts = [];
      await this.$store.dispatch(SCHEMA.GET, "account").then(result => {
        let schema = result.data;
        accounts.forEach(element => {
          let account = Object.assign({}, schema);
          account.broker = "fxcm";
          account.name = "FXCM [" + element.accountName + "]";
          account.loginId = element.accountId;
          account.token = this.token;
          account.live = this.real;
          account.balance = element.balance;
          account.enable = true;
          this.accounts.push(account);
        });
      });
      this.$emit("accounts", this.accounts);
      this.loading = !this.loading;
    },
    onToken() {
      this.loading = !this.loading;
      let url = "".concat(
        "accounts?broker=fxcm&token=",
        this.token,
        "&live=",
        this.real
      );
      ApiService.setHeader().then(() => {
        // fetch sales
        ApiService.get(url)
          .then(result => {
            this.convertAccounts(result.data);
          })
          .catch(e => {
            this.$store.dispatch(ERROR.PUSH, e);
          });
      });
    }
  }
};
</script>

<style>
</style>